//////LIBRARY//////
import React, { useEffect, useState, Fragment, useMemo } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { cloneDeep, isEmpty, isUndefined, isEqual, isNull } from 'lodash'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { bindActionCreators } from 'redux'
//////COMPONENTS//////
import { uriList } from '../../routings/settings/RouteList'
import Button from '../../components/Ui/Buttons'
import Modals from '../../components/Modals'
import Table from '../../components/Table'
import Tooltip from '../../components/Tooltip/Tooltip'
import DropdownCheckbox from '../../components/DropdownCheckbox'
import ActionsTable from '../../components/ActionsTable/ActionsTable'
import { initKioskManagerActionCreators, columnsActionCreators, tableActionCreators } from '../../store/actions'
import Theme from '../../theme/theme'
import UseCheckAll from '../../hooks/UseCheckAll'
import UseDatePicker from '../../hooks/UseDatePicker'
import userPrivileges from '../../constants/PrivilegesList'
import urlExport from '../../constants/UrlExport'
import { InitKioskBusinessRequestStatus, InitKioskBusinessRequestAction, InitKioskBusinessDistributor } from './Components'
import { ButtonWrapper, TextModal, DatePickerFilterLabel, TableHeaderCreateButton } from '../../theme/GlobalCss'
import TableTitle from '../../components/Table/components/TableTitle'
//////ASSETS//////
import Calendar from '../../assets/icones/global/calendar.svg'
import Validation from '../../assets/icones/global/check.svg'
import Cancel from '../../assets/icones/global/close-white.svg'

//////STYLED//////
const InitKioskBusinessManagerWrapper = styled.div`
	position: relative;
`
const DatePickerCreationIcon = styled.div`
	border-radius: 4px;
	background-color: ${(props) => props.theme.colors.primary};
	height: 32px;
	width: 32px;
	padding: 6px;
	box-sizing: border-box;
	cursor: pointer;
	background-image: url(${Calendar});
	background-repeat: no-repeat;
	background-size: 20px 20px;
	background-position: center;
	:hover {
		background-color: ${(props) => props.theme.colors.hoverPrimary};
	}
	transition: background-color 0.1s;
`
const TextModalWrapper = styled.div`
	width: 100%;
	height: auto;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
`
//////STYLED//////

const InitKioskBusinessManager = () => {
	const {
		user,
		translations,
		userKioskPerimeter,
		initKioskBusinessManager,
		initKioskBusinessFilters,
		isKioskUpdated,
		isSearchfieldUpdated,
		currentColumn,
		currentDir,
	} = useSelector(
		(state) => ({
			user: state.user,
			translations: state.languages.translations,
			userKioskPerimeter: state.user.identity.kioskSelected,
			initKioskBusinessManager: state.initKioskBusinessManager,
			userRolePrivileges: state.user.identity.rolePrivileges,
			initKioskBusinessFilters: state.initKioskBusinessManager.header,
			initKiosk: state.initKioskBusiness,
			initKioskRequestId: state.initKioskCreation,
			isKioskUpdated: state.initKioskBusinessManager.isKioskUpdated,
			isSearchfieldUpdated: state.columns.isSearchfieldUpdated,
			currentColumn: state.columns.currentColumn,
			currentDir: state.columns.currentDir,
		}),
		shallowEqual
	)

	const [swytch, setSwytch] = useState(false)
	let history = useHistory()

	// Date picker
	const [dateCreationShowModal, dateCreationOpenDateModalHandler, dateCreationRenderModal, dateCreationStateDate, setStartDate, setEndDate] =
		UseDatePicker({
			defaultDateStart: moment().startOf('day').subtract(3, 'months').toDate(),
			defaultDateEnd: moment().hours(23).minutes(59).toDate(),
		})

	// Modals
	const [showModalCancelRequest, setShowModalCancelRequest] = useState(false)
	const [showModalValidateEstimate, setShowModalValidateEstimate] = useState(false)
	const [showModalReactivateRequest, setShowModalReactivateRequest] = useState(false)
	const [showModalStartConstruction, setShowModalStartConstruction] = useState(false)
	const [showModalEndConstruction, setShowModalEndConstruction] = useState(false)
	const [showModalInstallSoftware, setShowModalInstallSoftware] = useState(false)
	const [showModalFinalizeSetup, setShowModalFinalizeSetup] = useState(false)
	const [showModalWorkshopControl, setShowModalWorkshopControl] = useState(false)
	const [row, setRow] = useState({})

	// Paging
	const [paging, setPaging] = useState({
		page: '0',
		size: '250',
		sort: 'reqKiosk.labelToManufacturer',
		nameDir: 'asc',
		sort_2: 'dateCreated',
		nameDir_2: 'asc',
	})

	// Search bar
	const [searchValue, setSearchValue] = useState()

	// Filters
	const [prevFilter, setPrevFilter] = useState({})
	const [filters, setFilters, handleCheckElements] = UseCheckAll(prevFilter)

	const [currentPerimeterKiosks, setCurrentPerimeterKiosks] = useState([])
	const actionsInitKioskManager = bindActionCreators(initKioskManagerActionCreators, useDispatch())
	const actionsColumns = bindActionCreators(columnsActionCreators, useDispatch())
	const actionsTable = bindActionCreators(tableActionCreators, useDispatch())

	// Columns
	const [columns, setColumns] = useState([])

	/////////////////////////////// HANDLER //////////////////////////////////////

	const handlePagingInitKioskBusinessManager = (paging) => {
		let sortMap = {}
		if (!isUndefined(currentColumn.value)) {
			sortMap = {
				sort: currentColumn.value,
				nameDir: currentDir.value,
			}
		} else {
			sortMap = {
				sort: 'reqKiosk.labelToManufacturer',
				nameDir: 'asc',
				sort_2: 'dateCreated',
				nameDir_2: 'asc',
			}
		}
		const pg = { ...paging, ...sortMap }
		setPaging(pg)
		// Test user, to get the good call accordingly
		actionsInitKioskManager.getKiosksBusinessView(handleFilterSend(), pg)
	}

	// handler search bar
	const handleSearchEnter = (e, val) => {
		if (e.keyCode !== 13) return
		setSearchValue(val)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleClickSearch = (refInput) => {
		setSearchValue(refInput.current.value)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleSubmit = () => {
		if (isEqual(filters, prevFilter)) return // guard to call if no change
		setPrevFilter(filters)

		// Force reset paging at zero, in case when filters are preventing any pagination with current size
		let pg = cloneDeep(paging)
		if (isUndefined(pg)) {
			pg = { page: '0', size: '250', sort: 'reqKiosk.labelToManufacturer', nameDir: 'asc', sort_2: 'dateCreated', nameDir_2: 'asc' }
		} else {
			pg.page = '0'
		}
		setPaging(pg)

		actionsInitKioskManager.getKiosksBusinessView(handleFilterSend(), pg)
	}

	const handleFilterSend = () => {
		const filtersIn = cloneDeep(filters)
		let searchFieldUpdated = {}
		let filtersOut = {}

		if (isSearchfieldUpdated) {
			searchFieldUpdated = {
				searchFieldUpdated: true,
			}
		} else {
			searchFieldUpdated = {
				searchFieldUpdated: false,
			}
		}
		filtersOut = { ...searchFieldUpdated, ...filtersIn }
		return {
			...filtersOut,
			withFilters: true,
			datesRange: {
				dateStart: dateCreationStateDate.date.startDate,
				dateEnd: dateCreationStateDate.date.endDate,
			},
		}
	}

	// Modal handlers
	const handleOpenModals = (row, modal) => {
		setRow(row)
		switch (modal) {
			case 'handleModalCancelRequest':
				setShowModalCancelRequest(true)
				break
			case 'handleModalValidateEstimate':
				setShowModalValidateEstimate(true)
				break
			case 'handleModalReactivateRequest':
				setShowModalReactivateRequest(true)
				break
			case 'handleModalStartConstruction':
				setShowModalStartConstruction(true)
				break
			case 'handleModalEndConstruction':
				setShowModalEndConstruction(true)
				break
			case 'handleModalInstallSoftware':
				setShowModalInstallSoftware(true)
				break
			case 'handleModalFinalizeSetup':
				setShowModalFinalizeSetup(true)
				break
			case 'handleModalWorkshopControl':
				setShowModalWorkshopControl(true)
				break
			default:
				break
		}
	}

	const handleCloseModals = (_dataRow) => {
		if (showModalCancelRequest) {
			setShowModalCancelRequest(false)
		}
		if (showModalValidateEstimate) {
			setShowModalValidateEstimate(false)
		}
		if (showModalReactivateRequest) {
			setShowModalReactivateRequest(false)
		}
		if (showModalStartConstruction) {
			setShowModalStartConstruction(false)
		}
		if (showModalEndConstruction) {
			setShowModalEndConstruction(false)
		}
		if (showModalInstallSoftware) {
			setShowModalInstallSoftware(false)
		}
		if (showModalFinalizeSetup) {
			setShowModalFinalizeSetup(false)
		}
		if (showModalWorkshopControl) {
			setShowModalWorkshopControl(false)
		}
	}

	// Actions
	const handleCancelRequest = (row) => {
		handleCloseModals()
		actionsInitKioskManager.putKioskBuild(row.id, 'CancelRequest')
	}

	const handleValidateEstimate = (row) => {
		handleCloseModals()
		actionsInitKioskManager.putKioskBuild(row.id, 'ValidateQuote')
	}

	const handleReactivateRequest = (row) => {
		handleCloseModals()
		actionsInitKioskManager.putKioskBuild(row.id, 'ReactivateRequest')
	}

	const handleStartConstruction = (row) => {
		handleCloseModals()
		actionsInitKioskManager.putKioskBuild(row.id, 'StartBuildRequest')
	}

	const handleEndConstruction = (row) => {
		handleCloseModals()
		actionsInitKioskManager.putKioskBuild(row.id, 'FinishBuildRequest')
	}

	const handleInstallSoftware = (row) => {
		handleCloseModals()
		actionsInitKioskManager.putKioskBuild(row.id, 'InstallSoftKioskRequest')
	}

	const handleFinalizeSetup = (row) => {
		handleCloseModals()
		actionsInitKioskManager.putKioskBuild(row.id, 'FinishConfigRequest')
	}

	const handleWorkshopControl = (row) => {
		handleCloseModals()
		actionsInitKioskManager.putKioskBuild(row.id, 'FactoryFloor')
	}

	const handleViewProductionSheet = (row) => {
		actionsInitKioskManager.viewProductionSheet(row.id)
	}

	// Redirect according to status
	const handleRedirect = (row, readOnly = false) => {
		const bankStatus = row.requestStatus.id === 6 ? true : false
		const articleStatus = row.requestStatus.id === 7 ? true : false
		const implantationStatus = row.requestStatus.id === 8 ? true : false
		const pricesStatus = row.requestStatus.id === 9 ? true : false
		const recapStatus = row.requestStatus.id >= 10 && row.requestStatus.id <= 19 ? true : false

		let urlPush = ''
		let step = ''

		/* if (definitionStatus) {
			urlPush = `${uriList.initKiosks}${uriList.initKioskBusinessManager}${uriList.kioskCreationDefinition}/${row.id}`
			step = 'definition'
		} else */ if (bankStatus) {
			urlPush = `${uriList.initKiosks}${uriList.initKioskBusinessManager}${uriList.kioskBankDetails}/${row.id}`
			step = 'bankDetails'
		} else if (articleStatus) {
			urlPush = `${uriList.initKiosks}${uriList.initKioskBusinessManager}${uriList.kioskAddItem}/${row.id}`
			step = 'addItems'
		} else if (implantationStatus) {
			urlPush = `${uriList.initKiosks}${uriList.initKioskBusinessManager}${uriList.kioskImplantation}/${row.id}`
			step = 'initKioskImplantation'
		} else if (pricesStatus) {
			urlPush = `${uriList.initKiosks}${uriList.initKioskBusinessManager}${uriList.kioskAddPrices}/${row.id}`
			step = 'addPrices'
		} else if (recapStatus) {
			urlPush = `${uriList.initKiosks}${uriList.initKioskBusinessManager}${uriList.kioskSummary}/${row.id}`
			step = 'summary'
		} else {
			// Default
			urlPush = `${uriList.initKiosks}${uriList.initKioskBusinessManager}${uriList.kioskCreationDefinition}/${row.id}`
			step = 'definition'
		}

		if (urlPush !== '') {
			actionsInitKioskManager.setRequestBusinessParams(row.id, row.requestStatus.id, readOnly, step)
			history.push(urlPush)
		}
	}

	const handleFinalizeRequest = (row) => {
		actionsInitKioskManager.setRequestBusinessParams(row.id, row.requestStatus.id)
		history.push(`${uriList.initKiosks}${uriList.initKioskBusinessManager}${uriList.kioskCreationDefinition}/${row.id}`)
	}

	/////////////////////////////// CONFIG //////////////////////////////////////

	useEffect(() => {
		setColumns([
			{
				columnReferential: 'kioskInCreation_requestId',
				dataHook: 'requestId',
				headerName: translations['page__initKiosk__kioskCreation_tableHeader_requestId'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'idRequest',
			},
			{
				columnReferential: 'kioskInCreation_requestName',
				dataHook: 'requestName',
				headerName: translations['page__initKiosk__kioskCreation_tableHeader_requestName'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'label',
			},
			{
				columnReferential: 'kioskInCreation_requestProgress',
				dataHook: 'progress',
				headerName: translations['page__initKiosk__kioskCreation_tableHeader_requestProgression'],
				sortable: true,
				isAuthorize: true,
				component: InitKioskBusinessRequestStatus,
				sortableId: 'progress',
			},
			{
				columnReferential: 'kioskInCreation_requestStatus',
				dataHook: 'requestStatus.translationKey',
				headerName: translations['page__initKiosk__kioskCreation_tableHeader_status'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
				sortableId: 'kioskRequestStatus.description',
			},
			{
				columnReferential: 'kioskInCreation_requiredAction',
				dataHook: 'requiredAction',
				headerName: translations['page__initKiosk__kioskCreation_tableHeader_requiredAction'],
				sortable: true,
				isAuthorize: true,
				component: InitKioskBusinessRequestAction,
			},
			{
				columnReferential: 'kioskInCreation_distributor',
				dataHook: 'distributorPicture',
				headerName: translations['page__initKiosk__kioskCreation_tableHeader_distributor'],
				sortable: true,
				isAuthorize: true,
				component: InitKioskBusinessDistributor,
				sortableId: 'reqDistr.company.labelToDisplay',
			},
			{
				columnReferential: 'kioskInCreation_kioskCode',
				dataHook: 'kioskCode',
				headerName: translations['page__initKiosk__kioskCreation_tableHeader_kioskCode'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'reqKiosk.labelToManufacturer',
			},
			{
				columnReferential: 'kioskInCreation_owner',
				dataHook: 'owner',
				headerName: translations['page__initKiosk__kioskCreation_tableHeader_owner'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'companyOwner.labelToDisplay',
			},
			{
				columnReferential: 'kioskInCreation_kioskName',
				dataHook: 'kioskName',
				headerName: translations['page__initKiosk__kioskCreation_tableHeader_kioskName'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'kiosk.description',
			},
			{
				columnReferential: 'kioskInCreation_clientKioskName',
				dataHook: 'customerKioskCode',
				headerName: translations['page__initKiosk__kioskCreation_tableHeader_customerKioskCode'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'reqKiosk.labelToOwner',
			},
			{
				columnReferential: 'kioskInCreation_store',
				dataHook: 'storeLabelToDisplay',
				headerName: translations['page__initKiosk__kioskCreation_tableHeader_store'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'companyStore.labelToDisplay',
			},
			{
				columnReferential: 'kioskInCreation_creationDate',
				dataHook: 'dateCreated',
				headerName: translations['page__initKiosk__kioskCreation_tableHeader_creationDate'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (!isNull(props.row.dateCreated) ? moment(props.row.dateCreated).format('DD/MM/YYYY HH:mm') : '-'),
				sortableId: 'dateCreated',
			},
			{
				columnReferential: 'kioskInCreation_installationDate',
				dataHook: 'dateInstall',
				headerName: translations['page__initKiosk__kioskCreation_tableHeader_installDesired'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (!isNull(props.row.dateInstall) ? moment(props.row.dateInstall).format('DD/MM/YYYY ') : '-'),
				sortableId: 'mi.dateInstallation',
			},
			{
				columnReferential: 'kioskInCreation_deliveryDate',
				dataHook: 'dateDelivery',
				headerName: translations['page__initKiosk__kioskCreation_tableHeader_deliveryScheduled'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (!isNull(props.row.dateDelivery) ? moment(props.row.dateDelivery).format('DD/MM/YYYY') : '-'),
				sortableId: 'mi.dateDeliveryScheduled',
			},
			{
				columnReferential: 'kioskInCreation_kioskModel',
				dataHook: 'kioskModel',
				headerName: translations['page__initKiosk__kioskCreation_tableHeader_kioskModel'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
				sortableId: 'reqKioskModel.label',
			},
			{
				columnReferential: 'kioskInCreation_displayStandNumber',
				dataHook: 'displayStandsNumber',
				headerName: translations['page__initKiosk__kioskCreation_tableHeader_rackNumber'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'racksNumber',
			},
			{
				columnReferential: 'kioskInCreation_lockerNumber',
				dataHook: 'lockersNumber',
				headerName: translations['page__initKiosk__kioskCreation_tableHeader_lockerNumber'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'lockersNumber',
			},
			{
				columnReferential: 'kioskInCreation_userToRequest',
				dataHook: 'userToRequest',
				headerName: translations['page__initKiosk__kioskCreation_tableHeader_manager'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'userSeller.lastName',
			},
			{
				action: true,
				isFixed: true,
				component: ActionsTable,
				checkRight: userPrivileges.action[22],
				withFilters: false,
				rest: {
					tooltipPart: 'initKioskBusinessManager',
					paperActionsList: [
						{
							name: translations['tooltip__admin__initKiosk__finalizeRequest'],
							clickAction: (row) => {
								handleFinalizeRequest(row)
							},
							isVisible: (row) => {
								return row.canVerifyDisplayStandRequest
							},
							//iconDef: Start,
							translationKey: 'tooltip__admin__initKiosk__finalizeRequest',
						},
						{
							name: translations['page__initKiosk__kioskCreation_tableHeader_modalAction_button_startBuild'],
							clickAction: (row) => {
								handleOpenModals(row, 'handleModalStartConstruction')
							},
							isVisible: (row) => row.canStartBuildRequest,
							//iconDef: Start,
							translationKey: 'tooltip__admin__initKiosk__startBuild',
						},
						{
							name: translations['page__initKiosk__kioskCreation_tableHeader_modalAction_button_buildFinished'],
							clickAction: (row) => {
								handleOpenModals(row, 'handleModalEndConstruction')
							},
							isVisible: (row) => row.canFinishBuildRequest,
							//iconDef: Start,
							translationKey: 'tooltip__admin__initKiosk__finishBuild',
						},
						{
							name: translations['page__initKiosk__kioskCreation_tableHeader_modalAction_button_configure'],
							clickAction: (row) => {
								handleRedirect(row)
							},
							isVisible: (row) => {
								return row.canConfigureRequest || (!row.canConfigureRequest && row?.requestStatus?.id === 11)
							},
							//iconDef: Start,
							translationKey: 'tooltip__admin__initKiosk__configureRequest',
						},
						{
							name: translations['page__initKiosk__kioskCreation_tableHeader_modalAction_button_KioskSoftIntall'],
							clickAction: (row) => {
								handleOpenModals(row, 'handleModalInstallSoftware')
							},
							isVisible: (row) => row.canInstallSoftKioskRequest,
							//iconDef: Start,
							translationKey: 'ref__actions__kioskInit_status_action_installKioskSoftware',
						},
						{
							name: translations['page__initKiosk__kioskCreation_tableHeader_modalAction_button_assignKiosk'],
							clickAction: (row) => {
								handleRedirect(row)
							},
							isVisible: (row) => {
								return row.canKioskAffectRequest
							},
							//icon: Start,
							translationKey: 'tooltip__admin__initKiosk__assignKiosk',
						},
						{
							name: translations['ref__actions__kioskInit_status_action_validateConfiguration'],
							clickAction: (row) => {
								handleOpenModals(row, 'handleModalFinalizeSetup')
							},
							isVisible: (row) => row.canFinishConfigRequest,
							//iconDef: Start,
							translationKey: 'tooltip__admin__initKiosk__finalizeConfiguration',
						},
						{
							name: translations['page__initKiosk__kioskCreation_tableHeader_modalAction_button_workshopControl'],
							clickAction: (row) => {
								handleOpenModals(row, 'handleModalWorkshopControl')
							},
							isVisible: (row) => row.canFactoryFloor,
							//iconDef: Start,
							translationKey: 'tooltip__admin__initKiosk__workshopControl',
						},
						{
							name: translations['page__initKiosk__kioskCreation_tableHeader_modalAction_button_validateQuote'],
							clickAction: (row) => {
								handleOpenModals(row, 'handleModalValidateEstimate')
							},
							isVisible: (row) => row.canValidateQuote,
							//iconDef: ValidateEstimate,
							translationKey: 'tooltip__admin__initKiosk__validateQutote',
						},
						{
							name: translations['page__initKiosk__kioskCreation_tableHeader_modalAction_button_reactivateRequest'],
							clickAction: (row) => {
								handleOpenModals(row, 'handleModalReactivateRequest')
							},
							isVisible: (row) => row.canReactivateRequest,
							//iconDef: Reactivate,
							translationKey: 'page__initKiosk__kioskCreation_tableHeader_modalAction_button_reactivateRequest',
						},
						{
							name: translations['page__initKiosk__kioskCreation_tableHeader_modalAction_button_viewProductionSheet'],
							clickAction: (row) => {
								handleViewProductionSheet(row)
							},
							isVisible: (row) => row.canShowProductionSheetRequest,
							//iconDef: ViewProduction,
							translationKey: 'tooltip__admin__initKiosk__viewProductionSheet',
						},
						{
							name: translations['tooltip__admin__initKiosk__see'],
							clickAction: (row) => {
								handleRedirect(row, true)
							},
							isVisible: (row) => {
								return row.canShowRequest
							},
							//icon: SeeIcon,
							translationKey: 'tooltip__admin__initKiosk__see',
						},
						{
							name: translations['page__initKiosk__kioskCreation_tableHeader_modalAction_button_cancelRequest'],
							clickAction: (row) => {
								handleOpenModals(row, 'handleModalCancelRequest')
							},
							isVisible: (row) => {
								return row.canCancelRequest
							},
							//iconDef: CancelRequest,
							translationKey: 'tooltip__admin__initKiosk__cancelRequest',
						},
					],
				},
			},
		])
	}, [translations])

	// Used for columns displaying (redux stored)
	const tableReferential = {
		idPageTable: 21,
		labelPageTable: 'kioskInCreation',
	}

	const [configTableTitle, setConfigTableTitle] = useState({
		actions: {
			searchBarComponent: {
				handleSearchEnter: handleSearchEnter,
				handleClickSearch: handleClickSearch,
				placeholder: translations['common__text__fastFilter_search'],
				handleReset: (refInput) => {
					refInput.current.value = ''
					setSearchValue('')
				},
			},

			dateLists: [
				() => (
					<Fragment>
						<label style={{ color: Theme.colors.table.body.text, marginRight: '10px', lineHeight: '32px' }}>
							{translations['common__fastFilter_generationDate']}
						</label>
						<DatePickerCreationIcon onClick={dateCreationOpenDateModalHandler} />
						<DatePickerFilterLabel>
							<span>
								{translations['page__global__admin__header_datePicker_from']}{' '}
								{isEqual(dateCreationStateDate.date.startDate, {})
									? moment(new Date()).subtract(3, 'months').format('DD/MM/YYYY HH:mm')
									: moment(dateCreationStateDate.date.startDate).format('DD/MM/YYYY HH:mm')}
							</span>
							<span>
								{translations['page__global__admin__header_datePicker_to']}{' '}
								{isEqual(dateCreationStateDate.date.endDate, {})
									? moment(new Date()).format('DD/MM/YYYY HH:mm')
									: moment(dateCreationStateDate.date.endDate).format('DD/MM/YYYY HH:mm')}
							</span>
						</DatePickerFilterLabel>
					</Fragment>
				),
			],
		},
		paging: { fnSendTo: (paging) => handlePagingInitKioskBusinessManager(paging) },
	})
	const [configTable, setConfigTable] = useState({})

	/////////////////////////////// USE EFFECT //////////////////////////////////////

	useEffect(() => {
		return function cleanUp() {
			actionsInitKioskManager.resetDataBusiness()
			actionsTable.resetPaggingConfig()
		}
	}, [])

	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)

		cfg.actions.searchBarComponent = {
			handleSearchEnter: handleSearchEnter,
			handleClickSearch: handleClickSearch,
			placeholder: translations['common__text__fastFilter_search'],
			defaultValue: searchValue,
			handleReset: (refInput) => {
				refInput.current.value = ''
				setSearchValue('')
			},
		}

		setConfigTableTitle(cfg)
	}, [searchValue])

	useEffect(() => {
		const filtersCP = cloneDeep(filters)
		filtersCP.searchField = searchValue
		setFilters(filtersCP)
	}, [searchValue])

	useEffect(() => {
		if (filters.searchField !== searchValue) return
		handleSubmit()
	}, [filters.searchField])

	useEffect(() => {
		setFilters(initKioskBusinessFilters)
		setPrevFilter(initKioskBusinessFilters)
	}, [translations, initKioskBusinessFilters])

	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)

		cfg.name = translations['page__initKiosk__kioskCreation_title']

		cfg.paging = {
			totalElements: initKioskBusinessManager.paging.totalElements,
			totalPages: initKioskBusinessManager.paging.totalPages,
			fnSendTo: (paging) => handlePagingInitKioskBusinessManager(paging),
		}

		cfg.actions.rest = [
			() => (
				<DropdownCheckbox
					title={translations['page__initKiosk__kioskCreation_filters_status']}
					data={filters.filtersSelection?.kioskRequestStatus.filterElements || []}
					translations={translations}
					toTranslate={true}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'kioskRequestStatus'}
				/>
			),

			() => (
				<DropdownCheckbox
					title={translations['page__initKiosk__kioskCreation_filters_owner']}
					data={filters.filtersSelection?.owner.filterElements || []}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'owner'}
				/>
			),

			() => (
				<DropdownCheckbox
					title={translations['page__initKiosk__kioskCreation_filters_store']}
					data={filters.filtersSelection?.store.filterElements || []}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'store'}
				/>
			),

			() => (
				<DropdownCheckbox
					title={translations['page__initKiosk__kioskCreation_filters_WDcontact']}
					data={filters.filtersSelection?.sellerWD.filterElements || []}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'sellerWD'}
				/>
			),
		]

		cfg.actions.dateLists = [
			() => (
				<Fragment>
					<label style={{ color: Theme.colors.table.body.text, marginRight: '10px', lineHeight: '32px' }}>
						{translations['page__initKiosk__kioskCreation_filters_creationDate']}
					</label>
					<DatePickerCreationIcon onClick={dateCreationOpenDateModalHandler} />
					<DatePickerFilterLabel>
						<span>
							{translations['page__global__admin__header_datePicker_from']}{' '}
							{isEqual(dateCreationStateDate.date.startDate, {})
								? moment(new Date()).subtract(3, 'months').format('DD/MM/YYYY HH:mm')
								: moment(dateCreationStateDate.date.startDate).format('DD/MM/YYYY HH:mm')}
						</span>
						<span>
							{translations['page__global__admin__header_datePicker_to']}{' '}
							{isEqual(dateCreationStateDate.date.endDate, {})
								? moment(new Date()).format('DD/MM/YYYY HH:mm')
								: moment(dateCreationStateDate.date.endDate).format('DD/MM/YYYY HH:mm')}
						</span>
					</DatePickerFilterLabel>
				</Fragment>
			),
		]

		setConfigTableTitle(cfg)
	}, [filters, translations, dateCreationStateDate])

	useEffect(() => {
		const cfgCp = cloneDeep(configTable)
		cfgCp.export = {
			privilege: userPrivileges.export[16],
			url: urlExport[15],
			bd: {
				filtersSelection: filters.filtersSelection,
				datesRange: { dateEnd: dateCreationStateDate.date.endDate, dateStart: dateCreationStateDate.date.startDate },
				searchField: searchValue,
				withFilters: true,
			},
		}

		setConfigTable(cfgCp)
	}, [translations, filters])

	useEffect(() => {
		if (!isUndefined(user) || !isEmpty(searchValue)) {
			setSwytch(true)
		}
	}, [user, searchValue])

	useEffect(() => {
		if (isUndefined(user)) return
		if (swytch) {
			let state_date = {}

			// Or default case
			state_date.startDate = moment().startOf('day').subtract(3, 'months').toDate()
			state_date.endDate = moment().hours(23).minutes(59).toDate()

			// And for state of datepicker
			setStartDate(moment(state_date.startDate).toDate())
			setEndDate(moment(state_date.endDate).toDate())

			const filtersCp = {
				withFilters: searchValue?.length > 0 ? true : false,
				filtersSelection: null,
				searchField: filters.searchField,
				datesRange: {
					dateStart: state_date.startDate,
					dateEnd: state_date.endDate,
				},
				searchFieldUpdated: false,
			}
			actionsInitKioskManager.getKiosksBusinessView(filtersCp)
			actionsColumns.setColumns([])

			setFilters(filtersCp)
		}
	}, [swytch])

	// If user is changing his perimeter, we need to make a back call
	useEffect(() => {
		if (!isEqual(userKioskPerimeter, currentPerimeterKiosks) && !isEmpty(currentPerimeterKiosks))
			actionsInitKioskManager.getKiosksBusinessView(handleFilterSend(), paging)
		setCurrentPerimeterKiosks(userKioskPerimeter)
	}, [userKioskPerimeter])

	useEffect(() => {
		const cfg = cloneDeep(configTableTitle)
		if (!isEmpty(initKioskBusinessManager) && !isUndefined(initKioskBusinessManager)) {
			cfg.paging = {
				totalElements: initKioskBusinessManager.paging.totalElements,
				totalPages: initKioskBusinessManager.paging.totalPages,
				fnSendTo: (paging) => handlePagingInitKioskBusinessManager(paging),
			}
			setConfigTableTitle(cfg)
		}
	}, [initKioskBusinessManager])

	useEffect(() => {
		if (dateCreationStateDate.showModal) {
			actionsInitKioskManager.getKiosksBusinessView(handleFilterSend(), paging)
		}
	}, [dateCreationShowModal])
	// we make call to refresh data when we devis is validate
	useEffect(() => {
		const pagingCp = cloneDeep(paging)
		if (isKioskUpdated) {
			actionsInitKioskManager.getKiosksBusinessView(handleFilterSend(), pagingCp)
		}
	}, [isKioskUpdated])

	///////////////////////////////// RENDER ///////////////////////////////////////

	const TableRender = useMemo(() => {
		return (
			<Table
				inputColumns={columns}
				inputData={initKioskBusinessManager.items}
				inputConfig={configTable}
				tableReferential={tableReferential}
				currentPaging={paging}
				actionSort={actionsInitKioskManager.getKiosksBusinessView}
			/>
		)
	}, [initKioskBusinessManager, columns, configTable, translations, paging])

	return (
		<Fragment>
			{
				<Modals
					title={translations['modal__initKiosk__kioskCreation__title__cancelRequest']}
					level="error"
					icon={true}
					showModal={showModalCancelRequest}
					closeModalHandler={handleCloseModals}
				>
					<TextModalWrapper>
						<TextModal>{translations['modal__initKiosk__kioskCreation__body__cancelRequest']} </TextModal>
					</TextModalWrapper>
					<ButtonWrapper>
						<Button
							actionHandler={handleCloseModals}
							text={translations['common__text__cancel']}
							bgColor={Theme.colors.error}
							margin="true"
							img={Cancel}
						/>
						<Button
							actionHandler={() => handleCancelRequest(row)}
							text={translations['common__text__validate']}
							bgColor={Theme.colors.validation}
							img={Validation}
						/>
					</ButtonWrapper>
				</Modals>
			}
			<Modals
				title={translations['modal__initKiosk__kioskCreation__title__validateQutote']}
				icon={true}
				showModal={showModalValidateEstimate}
				//showModal={true}
				closeModalHandler={handleCloseModals}
			>
				<TextModalWrapper>
					<TextModal>{translations['modal__initKiosk__kioskCreation__body__validateQutote']} </TextModal>
				</TextModalWrapper>
				<ButtonWrapper>
					<Button
						actionHandler={handleCloseModals}
						text={translations['common__text__cancel']}
						bgColor={Theme.colors.error}
						margin="true"
						img={Cancel}
					/>
					<Button
						actionHandler={() => handleValidateEstimate(row)}
						text={translations['common__text__validate']}
						bgColor={Theme.colors.validation}
						img={Validation}
					/>
				</ButtonWrapper>
			</Modals>
			<Modals
				title={translations['modal__initKiosk__kioskCreation__title__reactivateRequest']}
				level="error"
				icon={true}
				showModal={showModalReactivateRequest}
				closeModalHandler={handleCloseModals}
			>
				<TextModalWrapper>
					<TextModal>{translations['modal__initKiosk__kioskCreation__body__reactivateRequest']} </TextModal>
				</TextModalWrapper>
				<ButtonWrapper>
					<Button
						actionHandler={handleCloseModals}
						text={translations['common__text__cancel']}
						bgColor={Theme.colors.error}
						margin="true"
						img={Cancel}
					/>
					<Button
						actionHandler={() => handleReactivateRequest(row)}
						text={translations['common__text__validate']}
						bgColor={Theme.colors.validation}
						img={Validation}
					/>
				</ButtonWrapper>
			</Modals>
			<Modals
				title={translations['modal__initKiosk__kioskCreation__title__startBuild']}
				icon={true}
				showModal={showModalStartConstruction}
				closeModalHandler={handleCloseModals}
			>
				<TextModalWrapper>
					<TextModal>{translations['modal__initKiosk__kioskCreation__body__startBuild']} </TextModal>
				</TextModalWrapper>
				<ButtonWrapper>
					<Button
						actionHandler={handleCloseModals}
						text={translations['common__text__cancel']}
						bgColor={Theme.colors.error}
						margin="true"
						img={Cancel}
					/>
					<Button
						actionHandler={() => handleStartConstruction(row)}
						text={translations['common__text__validate']}
						bgColor={Theme.colors.validation}
						img={Validation}
					/>
				</ButtonWrapper>
			</Modals>
			<Modals
				title={translations['modal__initKiosk__kioskCreation__title__finishBuild']}
				icon={true}
				showModal={showModalEndConstruction}
				closeModalHandler={handleCloseModals}
			>
				<TextModalWrapper>
					<TextModal>{translations['modal__initKiosk__kioskCreation__body__finishBuild']} </TextModal>
				</TextModalWrapper>
				<ButtonWrapper>
					<Button
						actionHandler={handleCloseModals}
						text={translations['common__text__cancel']}
						bgColor={Theme.colors.error}
						margin="true"
						img={Cancel}
					/>
					<Button
						actionHandler={() => handleEndConstruction(row)}
						text={translations['common__text__validate']}
						bgColor={Theme.colors.validation}
						img={Validation}
					/>
				</ButtonWrapper>
			</Modals>
			<Modals
				title={translations['modal__initKiosk__kioskCreation__title__confirmKioskSoftInstall']}
				icon={true}
				showModal={showModalInstallSoftware}
				closeModalHandler={handleCloseModals}
			>
				<TextModalWrapper>
					<TextModal>{translations['modal__initKiosk__kioskCreation__body__confirmKioskSoftInstall']} </TextModal>
				</TextModalWrapper>
				<ButtonWrapper>
					<Button
						actionHandler={handleCloseModals}
						text={translations['common__text__cancel']}
						bgColor={Theme.colors.error}
						margin="true"
						img={Cancel}
					/>
					<Button
						actionHandler={() => handleInstallSoftware(row)}
						text={translations['common__text__validate']}
						bgColor={Theme.colors.validation}
						img={Validation}
					/>
				</ButtonWrapper>
			</Modals>
			<Modals
				title={translations['modal__initKiosk__kioskCreation_factoryFloor__title_finalizeConfig']}
				icon={true}
				showModal={showModalFinalizeSetup}
				closeModalHandler={handleCloseModals}
			>
				<TextModalWrapper>
					<TextModal>{translations['modal__initKiosk__kioskCreation_factoryFloor__body__receptionWS_validate']} </TextModal>
				</TextModalWrapper>
				<ButtonWrapper>
					<Button
						actionHandler={handleCloseModals}
						text={translations['common__text__cancel']}
						bgColor={Theme.colors.error}
						margin="true"
						img={Cancel}
					/>
					<Button
						actionHandler={() => handleFinalizeSetup(row)}
						text={translations['common__text__validate']}
						bgColor={Theme.colors.validation}
						img={Validation}
					/>
				</ButtonWrapper>
			</Modals>
			<Modals
				title={translations['modal__initKiosk__kioskCreation_factoryFloor__title']}
				icon={true}
				showModal={showModalWorkshopControl}
				closeModalHandler={handleCloseModals}
			>
				<TextModalWrapper>
					<TextModal>{translations['modal__initKiosk__kioskCreation_factoryFloor__body__certify']} </TextModal>
				</TextModalWrapper>
				<ButtonWrapper>
					<Button
						actionHandler={handleCloseModals}
						text={translations['common__text__cancel']}
						bgColor={Theme.colors.error}
						margin="true"
						img={Cancel}
					/>
					<Button
						actionHandler={() => handleWorkshopControl(row)}
						text={translations['common__text__validate']}
						bgColor={Theme.colors.validation}
						img={Validation}
					/>
				</ButtonWrapper>
			</Modals>
			{dateCreationRenderModal()}
			<InitKioskBusinessManagerWrapper>
				{
					//!isUndefined(find(user.identity.rolePrivileges.privileges, (o) => o.label === userPrivileges.buttonAction[1])) &&
					<Tooltip tooltipId={'addButton'} translationsKey={'tooltip__admin__initKiosk__kioskCreate'}>
						<TableHeaderCreateButton to={`${uriList.initKiosks}${uriList.initKioskBusinessManager}${uriList.kioskCreationDefinition}`} />
					</Tooltip>
				}
				{!isUndefined(translations) && !isUndefined(configTableTitle) && (
					<TableTitle inputConfig={configTableTitle} inputColumns={columns} tableReferential={tableReferential} />
				)}
				{!isUndefined(translations) && !isUndefined(configTable) && TableRender}
			</InitKioskBusinessManagerWrapper>
		</Fragment>
	)
}

InitKioskBusinessManager.propTypes = {}

InitKioskBusinessManager.defaultPropTypes = {}

export default InitKioskBusinessManager
